import React from 'react';
import { clsx } from 'clsx';
import { DowLoader } from './DowLoader';

// Small sizes stay a plain ring (they sit inside buttons); anything larger is
// a section/page loader and shows the DOW brand mark instead.
export const Spinner = ({ size = 'md', className = '', label }) => {
  if (size === 'xs' || size === 'sm') {
    return (
      <div
        className={clsx(
          'animate-spin rounded-full border-2 border-gray-300 border-t-primary-600',
          size === 'xs' ? 'h-4 w-4' : 'h-6 w-6',
          className
        )}
      />
    );
  }
  return <DowLoader size={size} label={label} className={className} />;
};
